if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // NordLykke: enable mobile swipe gallery inside the enlarged media modal
        this.classList.add('product-media-modal--swipe');
        this.buildSwipeNav();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      buildSwipeNav() {
        const dialog = this.querySelector('.product-media-modal__dialog');
        const container = this.querySelector('[role="document"]');
        if (!dialog || !container) return;
        if (container.children.length < 2) return;
        if (dialog.querySelector('.product-media-modal__nav')) return;

        const makeButton = (modifier, attr, label, path) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-media-modal__nav ' + modifier;
          button.setAttribute('aria-label', label);
          button.setAttribute(attr, '');
          button.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" width="20" height="20">' +
            '<path d="' + path + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          return button;
        };

        this.prevButton = makeButton('product-media-modal__nav--prev', 'data-modal-prev', 'Forrige bilde', 'M15 18l-6-6 6-6');
        this.nextButton = makeButton('product-media-modal__nav--next', 'data-modal-next', 'Neste bilde', 'M9 18l6-6-6-6');
        dialog.appendChild(this.prevButton);
        dialog.appendChild(this.nextButton);

        this.prevButton.addEventListener('click', () => this.scrollModalMedia(-1));
        this.nextButton.addEventListener('click', () => this.scrollModalMedia(1));

        let ticking = false;
        container.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              this.updateModalNav();
              ticking = false;
            });
          },
          { passive: true }
        );
      }

      scrollModalMedia(direction) {
        const container = this.querySelector('[role="document"]');
        if (!container) return;
        const width = container.clientWidth || 1;
        const current = Math.round(container.scrollLeft / width);
        const maxIndex = container.children.length - 1;
        const target = Math.max(0, Math.min(maxIndex, current + direction));
        container.scrollTo({ left: target * width, behavior: 'smooth' });
      }

      updateModalNav() {
        const container = this.querySelector('[role="document"]');
        if (!container || !this.prevButton || !this.nextButton) return;
        const width = container.clientWidth || 1;
        const index = Math.round(container.scrollLeft / width);
        const maxIndex = container.children.length - 1;
        this.prevButton.toggleAttribute('disabled', index <= 0);
        this.nextButton.toggleAttribute('disabled', index >= maxIndex);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');

        if (this.isMobile()) {
          // Horizontal swipe slider: jump (no smooth) to the tapped media without moving the page
          const children = Array.from(container.children);
          const index = Math.max(0, children.indexOf(activeMedia));
          container.scrollLeft = index * (container.clientWidth || 1);
          this.updateModalNav();
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
